(ns frontend.ui.component.lp-portal.report.component.horizontal-table.style
  (:require
   [common.util :as cu]
   [garden.util :refer [space-join]]
   [frontend.ui.style.theme.core :as theme]))

(defn scroll-container
  []
  {:overflow         :auto
   :position         :relative
   :background-color "inherit"})

(defn dynamic-table
  [props]
  (merge {:flex-direction   :column
          :font-size        :12px
          :min-width        :100%
          :border-collapse  :collapse
          :background-color "inherit"}
         (when (:fixed-width? props) {:table-layout "fixed"})))

(defn heading-tr
  []
  {:background-color (theme/color [:lp-report :horizontal-table :heading :background])})

(defn resolve-text-alignment
  [data-type idx]
  (if (= idx 0)
    {:text-align "left"}
    (case data-type
      :table-data-type/date
      {:text-align "right"}
      :table-data-type/currency
      {:text-align "right"}
      :table-data-type/multiple
      {:text-align "right"}
      :table-data-type/number
      {:text-align "right"}
      :table-data-type/percentage
      {:text-align "right"}
      :table-data-type/text
      {:text-align "left"}
      {:text-align "right"})))

(defn th-spanned
  [label]
  (merge (if (cu/blank-value? label)
           {:border "none"}
           {:border-left (space-join [(theme/border-width :medium) "solid"
                                      (theme/color [:table :border])])
            :color       (theme/color [:table :tr :even])
            :text-align  "center"
            :padding     "5px"})
         {:background-color (theme/color [:lp-report :table :heading-color :bg])}))

(defn th-heading
  [label idx data-type]
  (merge
   (if (cu/blank-value? label)
     {:border "none"}
     {:border (space-join [(theme/border-width :medium) "solid"
                           (theme/color [:table :border])])})
   (resolve-text-alignment data-type idx)
   {:background-color (theme/color [:lp-report :table :heading-color :bg])
    :padding "8px 12px"
    :color   (theme/color [:lp-report :table :heading-color :fg])}))

(defn th-info
  [label idx data-type]
  (merge (if (cu/blank-value? label)
           {:border "none"}
           {:border-left (space-join [(theme/border-width :medium) "solid"
                                      (theme/color [:table :border])])})
         (resolve-text-alignment data-type idx)
         {:background-color (theme/color [:table :tr :subheading2])
          :color   (theme/color [:table :tr :subheading-text])
          :padding "5px 12px"}))

(defn resolve-table-row-color
  [table-style index even-color odd-color]
  (case table-style
    :table-style/alternating
    (cond
      (odd? index) {:background-color odd-color}
      (even? index) {:background-color even-color}
      :else {:background-color "yellow"})
    :table-style/none
    {:background-color even-color}
    {:background-color even-color}))

(defn resolve-text-style
  [text-style]
  (case text-style
    "bold"
    {:font-weight "bold"}
    "italic"
    {:font-style "italic"}
    "underline"
    {:text-decoration "underline"}
    "bold-italic"
    {:font-weight "bold"
     :font-style  "italic"}
    "bold-underline"
    {:font-weight     "bold"
     :text-decoration "underline"}
    "italic-underline"
    {:font-style      "italic"
     :text-decoration "underline"}
    {}))

(defn data-row-horizontal-table
  [row-type row-highlight row-font-style row-style index even-color odd-color _sub-heading-color
   sub-total-color total-color empty-line-color table-style]
  (merge
   (when (cu/blank-value? row-type)
     (resolve-table-row-color table-style index even-color odd-color))
   (condp = row-type
     "subheading" {:font-weight "bold"}
     "subtotal" {:font-weight   "bold"
                 :border-bottom (space-join [(theme/border-width :medium) "solid"
                                             (theme/color [:palette :brand-3])])
                 :border-top    (space-join [(theme/border-width :medium) "solid"
                                             (theme/color [:palette :brand-3])])
                 :background-color sub-total-color}
     "total" {:font-weight   "bold"
              :border-bottom (space-join [(theme/border-width :medium) "solid"
                                          (theme/color [:palette :brand-3])])
              :border-top    (space-join [(theme/border-width :medium) "solid"
                                          (theme/color [:palette :brand-3])])
              :background-color total-color}
     "empty line" {:background-color empty-line-color
                   :height "20px"}
     {})
   (when-not (cu/blank-value? row-highlight)
     {:background-color row-highlight})
   (when (some #(= row-style (cu/str-trim-lcase %)) ["border top" "border bottom"])
     (case row-style
       "border top" {:border-top (space-join [(theme/border-width :medium) "solid"
                                              (theme/color [:palette :brand-3])])}
       "border bottom" {:border-bottom (space-join [(theme/border-width :medium) "solid"
                                                    (theme/color [:palette :brand-3])])}
       {}))
   (resolve-text-style row-font-style)
   {:white-space "nowrap"}))

(defn data-row-vertical-table
  [row-type row-highlight row-font-style index even-color odd-color sub-heading-color
   sub-total-color total-color empty-line-color table-style row-style props]
  (merge
   (when (cu/blank-value? row-type)
     (resolve-table-row-color table-style index even-color odd-color))
   (condp = row-type
     "subheading" {:font-weight      "bold"
                   :background-color sub-heading-color}
     "subtotal" {:font-weight      "bold"
                 :border-bottom    (space-join [(theme/border-width :medium) "solid"
                                                (theme/color [:palette :brand-3])])
                 :border-top       (space-join [(theme/border-width :medium) "solid"
                                                (theme/color [:palette :brand-3])])
                 :background-color sub-total-color}
     "total" {:font-weight      "bold"
              :border-bottom    (space-join [(theme/border-width :medium) "solid"
                                             (theme/color [:palette :brand-3])])
              :border-top       (space-join [(theme/border-width :medium) "solid"
                                             (theme/color [:palette :brand-3])])
              :background-color total-color}
     "empty line" {:background-color empty-line-color}
     {})
   (when-not (cu/blank-value? row-highlight)
     {:background-color row-highlight})
   (resolve-text-style row-font-style)
   (when (some #(= row-style (cu/str-trim-lcase %)) ["border top" "border bottom"])
     (case row-style
       "border top" {:border-top (space-join [(theme/border-width :medium) "solid"
                                              (theme/color [:palette :brand-3])])}
       "border bottom" {:border-bottom (space-join [(theme/border-width :medium) "solid"
                                                    (theme/color [:palette :brand-3])])}
       {}))
   (when-not (:fixed-width? props) {:white-space "nowrap"})))

(defn data-row-block-table-tabular
  [row-type row-highlight row-font-style row-style index even-color odd-color _heading-color _heading-info-color
   sub-heading-color sub-total-color total-color empty-line-color table-style]
  (merge
   (when (cu/blank-value? row-type)
     (resolve-table-row-color table-style index even-color odd-color))
   (condp = row-type
     "subheading" {:font-weight      "bold"
                   :background-color sub-heading-color
                   :padding          "5px"}
     "subtotal" {:background-color sub-total-color}
     "total" {:background-color total-color}
     "empty line" {:background-color empty-line-color}
     {})
   (when-not (cu/blank-value? row-highlight)
     {:background-color row-highlight})
   (when (some #(= row-style (cu/str-trim-lcase %)) ["border top" "border bottom"])
     (case row-style
       "border top" {:border-top (space-join [(theme/border-width :medium) "solid"
                                              (theme/color [:palette :brand-3])])}
       "border bottom" {:border-bottom (space-join [(theme/border-width :medium) "solid"
                                                    (theme/color [:palette :brand-3])])}
       {}))
   (resolve-text-style row-font-style)))

(defn data-row-td
  [column-alignment data-type column-color column-font-style column-style idx props]
  (merge {}
         (if-not (cu/blank-value? column-alignment)
           {:text-align column-alignment}
           (resolve-text-alignment data-type idx))
         (when (some #(= column-style (cu/str-trim-lcase %)) ["border left" "border right"])
           (case column-style
             "border left" {:border-left (space-join [(theme/border-width :medium) "solid"
                                                      (theme/color [:palette :brand-3])])}
             "border right" {:border-right (space-join [(theme/border-width :medium) "solid"
                                                        (theme/color [:palette :brand-3])])}
             {}))
         (when-not (cu/blank-value? column-color) {:background-color column-color})
         {:padding "8px 12px"}
         (resolve-text-style column-font-style)
         (when (:fixed-width? props) {:width "100px"})))

(defn data-row-block-table-stacked
  [row-type _row-highlight _row-font-style]
  (merge
   (condp = row-type
     "heading spanned" {}
     "heading" {}
     "heading info" {}
     "subheading" {}
     "subtotal" {}
     "total" {}
     "empty line" {}
     {}
   )
  ))

(defn data-row-td-heading-stacked
  [column-font-style row-type]
  (merge (condp = row-type
           "heading spanned" {}
           "heading" {}
           "heading info" {}
           "subheading" {}
           "subtotal" {}
           "total" {}
           "empty line" {}
           {})
         {:font-weight column-font-style
          :padding     "0px 0 4px"
          :font-size (if (= (theme/get-theme) :theme.lp-portal/lifeline)
                       "17px"
                       "12px")}
  ))

(defn td-stacked
  []
  (merge
   {:text-align "left"
    :font-size  (if (= (theme/get-theme) :theme.lp-portal/lifeline)
                  "13px"
                  "17px")
    :padding    "0px 0px 12px"
    :color      (theme/color [:lp-report :table :font-color])}))
